import { useMemo, useRef } from 'react'
import { useSelector } from 'react-redux'
import { Legend } from '../../../../../../../common/chart/legend'
import { PieChartContainer } from '../../../../../../../common/chart/pieChart'
import { Notification } from '../../../../../../../common/notification'
import { getUnique } from '../../../../../../../helpers/common'
import { formatText, valToPercent } from '../../../../../../../helpers/value'
import { selectBreakdown } from '../../../../store/slice'

export const PieChartComponent = () => {
  const chartId = useRef(getUnique())
  const data = useSelector(selectBreakdown)
  const locale = useSelector((state) => state.i18n.locale)

  const total = data.reduce((sum, item) => sum + item.scoreValue, 0)
  const dataPercent = data.map((item) => ({
    ...item,
    percent: item.scoreValue / total,
  }))

  const dataChart = useMemo(() => {
    const arrColor = ['#006AA6', '#F49966', '#FF596A']
    return dataPercent.map((item, index) => ({
      index,
      isI18n: false,
      value: Number(item.percent),
      name: formatText(item.riskDriverName),
      color: arrColor[index],
    }))
  }, [dataPercent])

  if (dataChart.length === 0)
    return (
      <div className="dFlex justifyContentCenter" style={{ height: 300 }}>
        <Notification />
      </div>
    )

  return (
    <div
      className="mt2 dBlock alignItemsCenter gap2"
      id="scoreBreakdownChartId"
    >
      <div className="dFlex justifyContentCenter mb4">
        <PieChartContainer
          chartId={chartId.current}
          innerRadius={75}
          outerRadius={120}
          width={250}
          height={250}
          data={dataChart}
          isLabelActive={false}
          formatValueTooltip={(val) => valToPercent(val, locale, false, true)}
          label={true}
          locale={locale}
        />
      </div>
      <Legend
        chartId={chartId.current}
        className="dFlex justifyContentCenter gap4 mb2"
        items={dataChart.map((item, index) => ({
          isI18n: item.isI18n,
          title: item.name,
          color: item.color,
          pieIndex: index,
        }))}
      />
    </div>
  )
}

PieChartComponent.propTypes = {}
